import { render, staticRenderFns } from "./Link.htm?vue&type=template&id=13c90741&scoped=true&"
import script from "./Link.ts?vue&type=script&lang=js&"
export * from "./Link.ts?vue&type=script&lang=js&"
import style0 from "./Link.scss?vue&type=style&index=0&id=13c90741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c90741",
  null
  
)

export default component.exports